import { quoteString } from './quote-string.tsx';

// Check if string have inner spaces
const haveSpaces = (s: string) => /\s/g.test(s.trim());

export const sanitizeClauseName = (clauseName: string) => {
	if (haveSpaces(clauseName)) {
		return quoteString(clauseName);
	}

	return clauseName;
};
